const baseMixpanelUrl = `https://mixpanel.com/project/${import.meta.env.VITE_MIXPANEL_PROJECT_ID}`;

const urls = {
  directoryUrl: `${import.meta.env.VITE_API_DIRECTORY_URL}/api/v2/sites`,
  reviewAppUrl: `${import.meta.env.VITE_PR_API_URL}`,
  switchAppUrl: `${import.meta.env.VITE_SWITCH_API_URL}`,
  organisationsUrl: `${import.meta.env.VITE_ORGANISATIONS_URL}`,

  baseOrganisationsUrl: url => `${url}/organisations-api/`,
  baseInductionUrl: url => `${url}/api/`,
  baseSwitchUrl: url => `${url}/switch-api/`,

  config: '/v2/config',
  switchApi: {
    revokeUser: {
      create: '/v1/revoke_users',
    },
  },
  organisationsApi: {
    organisations: {
      admins: {
        create: '/v1/admins/organisations',
        index: '/v1/admins/organisations',
        show: organisationId => `/v1/admins/organisations/${organisationId}`,
        update: organisationId => `/v1/admins/organisations/${organisationId}`,
        hospitals: {
          destroy: (organisationId, hospitalId) =>
            `/v1/admins/organisations/${organisationId}/hospitals/${hospitalId}`,
          index: organisationId =>
            `/v1/admins/organisations/${organisationId}/hospitals`,
        },
      },
      userOrganisations: {
        index: '/v1/user_organisations',
      },
      adminedOrganisations: {
        index: '/v1/admined_organisations',
      },
      show: organisationId => `/v1/organisations/${organisationId}`,
    },
  },
  charts: {
    defaults: '/v2/admins/charts/defaults',
    directoryViews: '/v2/admins/charts/directory_views',
    roles: '/v2/admins/charts/roles',
    signups: '/v2/admins/charts/signups',
    v3: {
      data: '/v3/admins/charts/data',
    },
  },
  enquiries: {
    create: '/v2/support_tickets',
  },
  mixpanel: {
    profile: mixpanelId =>
      `${baseMixpanelUrl}/view/${import.meta.env.VITE_MIXPANEL_PROJECT_ID}/app/profile#distinct_id=${mixpanelId}`,
  },
  sessionToken: {
    create: '/v2/session_tokens',
    destroy: '/v2/session_tokens',
  },
  confirmation: {
    request: '/v2/confirmations',
    confirm: confirmationToken => `/v2/confirmations/${confirmationToken}`,
  },
  passwordResets: {
    request: '/v2/password_resets',
    reset: passwordResetToken => `/v2/password_resets/${passwordResetToken}`,
    
  },
  authEmail: {
    create: (userId, type) => `v3/users/${userId}/generate_authentication_email?email_type=${type}`
  },
  users: {
    index: 'v2/users',
    create: 'v2/users',
    show: userId => `/v2/users/${userId}`,
    update: userId => `/v2/users/${userId}`,
    confirm: userId => `/v2/admins/users/${userId}/confirmations`,
    hardDelete: userId => `/v2/users/${userId}/forget`,
    recover: userId => `/v2/users/${userId}/recover`,
    logoutEverywhere: userId => `/v3/users/${userId}/logout_everywhere`,
    softDelete: userId => `/v2/users/${userId}`,
    pbrnVerification: {
      index: '/v2/admins/users/require_pbrn_verification',
      update: userId => `/v2/admins/users/${userId}/pbrn_verification`,
    },
    defaultHospital: {
      create: userId => `/v2/users/${userId}/default_hospitals`,
    },
    hospitals: {
      admined: {
        create: (userId, hospitalId) =>
          `/v2/users/${userId}/hospitals/${hospitalId}/admined`,
        destroy: (userId, hospitalId) =>
          `/v2/users/${userId}/hospitals/${hospitalId}/admined`,
      },
      promote_to_admin: {
        create: (userId, hospitalId) =>
          `/v2/users/${userId}/hospitals/${hospitalId}/promote_to_admin`,
      },
    },
    organisations: {
      admined: {
        show: userId => `v1/users/${userId}/admined_organisations`,
        create: (userId, orgId) =>
          `/v1/users/${userId}/organisations/${orgId}/admined`,
        destroy: (userId, orgId) =>
          `/v1/users/${userId}/organisations/${orgId}/admined`,
      },
    },
    v3: {
      updateGdprConsent: userId => `/v3/users/${userId}/update_gdpr_consent`,
    },
  },
  admins: {
    workspaces: {
      index: `/v3/admins/workspaces`,
      workspaceRelatedIds: userId => `/v3/users/${userId}/workspace_ids`,
    },
  },

  hospitals: {
    index: '/v2/hospitals',
    create: '/v2/hospitals',
    show: hospitalId => `/v2/hospitals/${hospitalId}`,
    update: hospitalId => `/v2/hospitals/${hospitalId}`,
    charts: {
      defaults: hospitalId => `/v2/hospitals/${hospitalId}/charts/defaults`,
      directoryViews: hospitalId =>
        `/v2/hospitals/${hospitalId}/charts/directory_views`,
      roles: hospitalId => `/v2/hospitals/${hospitalId}/charts/roles`,
      usage: hospitalId => `/v2/hospitals/${hospitalId}/charts/usage`,
      v3: {
        data: hospitalId => `/v3/hospitals/${hospitalId}/charts/data`,
        events: hospitalId => `/v3/hospitals/${hospitalId}/charts/events`,
      },
    },
    favouriteNumbers: {
      index: hospitalId => `/v2/hospitals/${hospitalId}/numbers/favourited`,
      create: (hospitalId, numberId) =>
        `/v2/hospitals/${hospitalId}/numbers/${numberId}/favourite`,
      destroy: (hospitalId, numberId) =>
        `/v2/hospitals/${hospitalId}/numbers/${numberId}/favourite`,
    },
    numbers: {
      index: hospitalId => `/v3/hospitals/${hospitalId}/numbers`,
      create: hospitalId => `/v3/hospitals/${hospitalId}/numbers`,
      new: hospitalId => `/v3/hospitals/${hospitalId}/numbers/new`,
      show: (hospitalId, numberId) =>
        `/v3/hospitals/${hospitalId}/numbers/${numberId}`,
      update: (hospitalId, numberId) =>
        `/v3/hospitals/${hospitalId}/numbers/${numberId}`,
      destroy: (hospitalId, numberId) =>
        `/v3/hospitals/${hospitalId}/numbers/${numberId}`,
      edit: (hospitalId, numberId) =>
        `/v3/hospitals/${hospitalId}/numbers/${numberId}/edit`,
      lock: (hospitalId, numberId) =>
        `/v3/hospitals/${hospitalId}/numbers/${numberId}/lock_unlock_number`,
    },
    numbersCopy: {
      new: hospitalId => `/v2/admins/hospitals/${hospitalId}/copy_numbers`,
      create: hospitalId => `/v2/admins/hospitals/${hospitalId}/copy_numbers`,
    },
    numbersImport: {
      validate: hospitalId =>
        `/v3/hospitals/${hospitalId}/import_numbers/validate`,
      create: hospitalId => `/v3/hospitals/${hospitalId}/import_numbers`,
    },
    numbersExport: {
      index: hospitalId => `/v3/hospitals/${hospitalId}/export_numbers`,
    },
    exclusionList: {
      index: hospitalId => `/v3/hospitals/${hospitalId}/exclusion_lists`,
      create: hospitalId => `/v3/hospitals/${hospitalId}/exclusion_lists`,
      new: hospitalId => `/v3/hospitals/${hospitalId}/exclusion_lists/new`,
      show: (hospitalId, numberId) =>
        `/v3/hospitals/${hospitalId}/exclusion_lists/${numberId}`,
      update: (hospitalId, numberId) =>
        `/v3/hospitals/${hospitalId}/exclusion_lists/${numberId}`,
      destroy: (hospitalId, numberId) =>
        `/v3/hospitals/${hospitalId}/exclusion_lists/${numberId}`,
      edit: (hospitalId, numberId) =>
        `/v3/hospitals/${hospitalId}/exclusion_lists/${numberId}/edit`,
    },
    invites: {
      index: hospitalId => `/v2/hospitals/${hospitalId}/invites`,
      create: hospitalId => `/v2/hospitals/${hospitalId}/invites`,
      destroy: (hospitalId, inviteId) =>
        `/v2/hospitals/${hospitalId}/invites/${inviteId}`,
      pending: {
        index: hospitalId => `/v2/hospitals/${hospitalId}/pending_invites`,
        destroy: (hospitalId, inviteId) =>
          `/v2/hospitals/${hospitalId}/pending_invites/${inviteId}`,
      },
      requests: {
        index: hospitalId => `/v2/hospitals/${hospitalId}/invite_requests`,
        create: hospitalId => `/v2/hospitals/${hospitalId}/invite_requests`,
        destroy: (hospitalId, inviteRequestId) =>
          `/v2/hospitals/${hospitalId}/invite_requests/${inviteRequestId}`,
      },
    },
    whitelistedDomains: {
      index: hospitalId => `/v2/hospitals/${hospitalId}/whitelisted_domains`,
      create: hospitalId => `/v2/hospitals/${hospitalId}/whitelisted_domains`,
      show: (hospitalId, domainId) =>
        `/v2/hospitals/${hospitalId}/whitelisted_domains/${domainId}`,
      destroy: (hospitalId, domainId) =>
        `/v2/hospitals/${hospitalId}/whitelisted_domains/${domainId}`,
      users: {
        show: (hospitalId, domainId) =>
          `/v2/hospitals/${hospitalId}/whitelisted_domains/${domainId}/users`,
      },
    },
    whitelistedUsers: {
      index: hospitalId =>
        `/v2/hospitals/${hospitalId}/whitelisted_user_hospitals`,
    },
  },
  workspaces: {
    emails: {
      index: workspaceId => `/v3/workspaces/${workspaceId}/emails`,
      create: workspaceId => `/v3/workspaces/${workspaceId}/emails`,
      new: workspaceId => `/v3/workspaces/${workspaceId}/emails/new`,
      update: (workspaceId, emailId) =>
        `/v3/workspaces/${workspaceId}/emails/${emailId}`,
      show: (workspaceId, emailId) =>
        `/v3/workspaces/${workspaceId}/emails/${emailId}`,
      destroy: (workspaceId, emailId) =>
        `/v3/workspaces/${workspaceId}/emails/${emailId}`,
      edit: (workspaceId, emailId) =>
        `/v3/workspaces/${workspaceId}/emails/${emailId}/edit`,
    },
  },
  favouriteHospitals: {
    index: '/v2/hospitals/favourited',
    create: hospitalId => `/v2/hospitals/${hospitalId}/favourite`,
    destroy: hospitalId => `/v2/hospitals/${hospitalId}/favourite`,
  },
  campaigns: {
    index: '/v3/admins/campaigns',
    create: '/v3/admins/campaigns',
    update: campaignId => `/v3/admins/campaigns/${campaignId}`,
    show: campaignId => `/v3/admins/campaigns/${campaignId}`,
  },
};

export default urls;
